import { ApiParameter, del, get, post, request } from "@insite/client-framework/Services/ApiService";
import { RequestForQuoteFormModel } from "@tCooneyBrothers/ApiModels";

const requestForQuoteUrl = "/api/v2/emailnew/RFQ";

export async function getRequestForQuoteFormFields() {
    try {
        const fieldCollection = await get<RequestForQuoteFormModel[]>(`${requestForQuoteUrl}`, {})
            .then(response => {
                return response;
            })
            .catch(err => {
                // eslint-disable-next-line no-console
                console.error("Console error", err);
            });
        return fieldCollection;
        // eslint-disable-next-line no-empty
    } catch (error) { }
}

export function addRequestForQuoteFormFields(parameter: RequestForQuoteFormModel) {
    const formData = new FormData();
    formData.append("rfqrequest", JSON.stringify(parameter.rfqrequest));

    if (parameter?.attachment?.attachment !== null) {
        formData.append("attachment", parameter.attachment.attachment);
    }

    return request<RequestForQuoteFormModel>(requestForQuoteUrl, "POST", {}, formData);
}
